import * as React from 'react';
import { Link } from 'react-router-dom';
import Person from 'src/entities/Person';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import User from 'src/entities/User';
import ProfileCardContainer from 'src/modules/my-account/my-profile-index/partials/ProfileCard.container';
import MyAccountHeaderComponent from 'src/modules/my-account/partials/MyAccountHeader.component';

export interface MyProfileIndexProps {
  user: User;
  physicalPerson: PhysicalPerson;
  juridicalPersons?: Person[];
}

const MyProfileIndexComponent: React.StatelessComponent<MyProfileIndexProps> = (props: MyProfileIndexProps) => (
  <section>
    <div className="container">
      <MyAccountHeaderComponent
        pageTitle="Mi cuenta"
        showSubTitle={true}
      />
      <div className="row">
        <ProfileCardContainer
          profileId={props.physicalPerson.id}
          name={props.physicalPerson.displayName}
          juridical={false}
          isDefaultProfile={props.user.defaultProfile.personType === 'physical'
            && props.user.defaultProfile.id === props.physicalPerson.id}
        />
        {
          props.juridicalPersons ?
            props.juridicalPersons.map((juridicalPerson) => (
              <ProfileCardContainer
                key={juridicalPerson.id!}
                profileId={juridicalPerson.id!}
                name={juridicalPerson.displayName}
                juridical={true}
                isDefaultProfile={props.user.defaultProfile.personType === 'juridical'
                  && props.user.defaultProfile.id === juridicalPerson.id}
              />
            )) : []
        }
        <div className="col-xs-6 col-md-6 col-lg-4">
          <div className="simple-card tab text-center border-dashed b-primary-dark pointer">
            <Link to="/mi-cuenta/perfil/juridico/editar/">
              <div className="gap-30" />
              <div className="gap-5" />
              <h4 className="text-center f-s-16">
                <span className="span-white">
                  Añadir otro perfil
            </span>
                <br />
                <span className="primary-font f-w-100 span-white">
                  Persona jurídica
            </span>
              </h4>
              <div className="deco-dashed border-bottom-dashed b-primary-dark" />
              <div className="gap-30" />
              <div className="gap-10" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default MyProfileIndexComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/my-profile-index/MyProfileIndex.component.tsx